import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import Areas from "@/pages/Areas";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import LeakTest from "@/pages/LeakTest";
import Gallery from "@/pages/Gallery";
import Tools from "@/pages/Tools";
import RebateFinder from "@/pages/RebateFinder";
import PricingGuide from "@/pages/PricingGuide";
import PressureTest from "@/pages/PressureTest";
import HotWaterDecision from "@/pages/HotWaterDecision";
import PhotoUpload from "@/pages/PhotoUpload";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services/:slug" element={<ServicePage />} />
          <Route path="/areas" element={<Areas />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/tools/leak-test" element={<LeakTest />} />
          <Route path="/leak-test" element={<LeakTest />} />
          <Route path="/tools/rebate-finder" element={<RebateFinder />} />
          <Route path="/rebate-finder" element={<RebateFinder />} />
          <Route path="/tools/pressure-test" element={<PressureTest />} />
          <Route path="/tools/hot-water-decision" element={<HotWaterDecision />} />
          <Route path="/pricing" element={<PricingGuide />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/work" element={<Gallery />} />
          <Route path="/upload" element={<PhotoUpload />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
